import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('deviceGroups', ['cachedGroups', 'selectedGroup']),
}

export const Methods = mapActions('deviceGroups', [
  'selectGroup',
  'fetchGroups',
  'updateGroup',
])
